interface CustodianItem {
  custodianCode: string;
  custodianId: number;
  custodianName: string;
}

export default class Custodian {
  custodians: CustodianItem;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(state: any) {
    this.custodians = state.custodians;
  }

  getNameById(custodianId: number): string {
    if (custodianId !== this.custodians.custodianId) {
      throw new Error(`Custodian with ID: ${custodianId} does not exist`);
    }

    return this.custodians.custodianName;
  }

  getIdByName(custodianName: string): number {
    if (custodianName !== this.custodians.custodianCode) {
      throw new Error(`Custodian with Name: ${custodianName} does not exist`);
    }

    return this.custodians.custodianId;
  }
}
